import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/auth.models';

@Injectable({ providedIn: 'root' })
export class UserProfileService {
  private availablePointsSubject = new BehaviorSubject<string>('0');
  private coinValueSubject = new BehaviorSubject<string>('0.00');
  private empName = new BehaviorSubject<string>('');
  private currencyName = new BehaviorSubject<string>('');

  constructor(private http: HttpClient) {}

  // Sample user API
  getAll() {
    return this.http.get<User[]>(`api/users`);
  }

  register(user: User) {
    return this.http.post(`/users/register`, user);
  }

  // Available Points
  setAvailablePoints(points: string) {
    this.availablePointsSubject.next(points);
  }

  getAvailablePoints(): Observable<string> {
    return this.availablePointsSubject.asObservable();
  }

  // Coin Value
  setCoinValue(value: string) {
    this.coinValueSubject.next(value);
  }

  getCoinValue(): Observable<string> {
    return this.coinValueSubject.asObservable();
  }

  // EMP_NAME
  setEmpName(name: string) {
    this.empName.next(name);
  }

  getEmpName(): Observable<string> {
    return this.empName.asObservable();
  }

  // Currency Name
  setCurrencyName(cname: string) {
    this.currencyName.next(cname);
  }

  getCurrencyName(): Observable<string> {
    return this.currencyName.asObservable();
  }
  
}